import React from "react";
import { DashboardDealsOverview } from "../components";

export const Dashboard = () => {
  return <DashboardDealsOverview />;
};

export default Dashboard;
